import './calculatorApi';
import './functionalitiesApi';
import './termsAndConditionsApi';
import './accountApi';
import './additionalBorrowerInfoApi';
import './investmentsApi';
import './loanApplicationsApi';
import './preContractualApi';
import './solvencyDeclarationApi';
import './specialConditionsApi';
import './publicCalculatorApi';
import { baseApi } from './baseApi';
import { publicBaseApi } from './publicBaseApi';
export const apiReducers = {
    [baseApi.reducerPath]: baseApi.reducer,
    [publicBaseApi.reducerPath]: publicBaseApi.reducer,
};
export const apiMiddlewares = [baseApi.middleware, publicBaseApi.middleware];
